import { IsNotEmpty, IsOptional, IsString, IsUrl, IsUUID, Matches, MinLength, ValidateIf, ValidateNested } from 'class-validator';
import { Base64AllowedMimeTypes, MaxBase64FileSize } from '../../decorators';
import { FileUploadDto } from './file.dto';
import { ALLOWED_USER_AVATAR_MIME_TYPES } from '../../constants';
import { Type } from 'class-transformer';

export class EventSponsorDto {
	id: string;
	eventId: string;
	sponsorName: string;
	sponsorUrl: string;
	avatarId: string;
	order: number;
}

export class EditEventSponsorDto {
	@IsOptional()
	@IsUUID()
	id?: string;

	@IsString()
	@MinLength(2, { message: 'Sponsor name is required' })
	@IsNotEmpty({ message: 'Sponsor name is required' })
	sponsorName: string;

	@IsString()
	@Matches(/^(https:\/\/)?.+/, { message: 'Link should start with https:// protocol' })
	@IsUrl({ protocols: ['https'], require_protocol: false, require_valid_protocol: false }, { message: 'Invalid link' })
	@IsNotEmpty({ message: 'Sponsor link is required' })
	@MinLength(5, { message: 'Sponsor link is required' })
	sponsorUrl: string;

	@IsOptional()
	@IsUUID()
	avatarId?: string;

	@ValidateIf((o) => !o.avatarId)
	@IsNotEmpty({ message: 'Sponsor avatar is required' })
	@ValidateNested()
	@Type(() => FileUploadDto)
	@MaxBase64FileSize(20)
	@Base64AllowedMimeTypes(ALLOWED_USER_AVATAR_MIME_TYPES)
	avatarImg?: FileUploadDto | null;
}

export class EditEventLeaderDto {
	@IsUUID()
	@IsNotEmpty()
	id: string;
}
